import { render, staticRenderFns } from "./account-collections-overview.vue?vue&type=template&id=7ca5b45c"
import script from "./account-collections-overview.vue?vue&type=script&lang=js"
export * from "./account-collections-overview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports